/**
 * Defines possible states for the notification store
 */
export enum StoreStatus {
  notInitialized = "NOT_INITIALIZED",
  loading = "LOADING",
  ready = "ready",
  error = "error",
}
